// eslint-disable-next-line @typescript-eslint/naming-convention
declare const _VERSION: string;

// eslint-disable-next-line @typescript-eslint/naming-convention
declare const _FRAME_URL: string;

export const env = {
  version: _VERSION,
  frameUrl: _FRAME_URL,
};
